import React from 'react';
import styles from './consultancyStep.module.css';

interface StepDescriptionProps {
  children: React.ReactNode;
  className?: string;
}

const StepDescription: React.FC<StepDescriptionProps> = ({ children, className = '' }) => (
  <div className={`${styles.stepDescription} ${className}`.trim()}>{children}</div>
);

export default StepDescription;
